import React, { useContext, useState } from 'react';
import { ContentQueryContext } from 'ricos-content-query';
import { ToolbarContext, ModalContext } from 'ricos-context';
import { Decoration_Type, CUSTOM_LINK } from 'wix-rich-content-common';
import { getLinkModalProps } from 'wix-rich-content-toolbars-modals';
import { ToolbarButton } from 'wix-rich-content-toolbars-ui';

const EditLinkButton = ({ toolbarItem }) => {
  var _a, _b, _c;
  const contentQueryService = useContext(ContentQueryContext);
  const dataHook = (_a = toolbarItem.presentation) == null ? void 0 : _a.dataHook;
  const id = `${Decoration_Type.LINK}.modal`;
  const { isMobile, t, getEditorCommands, linkPanelData, experiments } = useContext(ToolbarContext);
  const modalService = useContext(ModalContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const editorCommands = getEditorCommands == null ? void 0 : getEditorCommands();
  if (!linkPanelData) {
    return null;
  }
  const { onLinkAdd, linkSettings = {} } = linkPanelData;
  const { linkData } = getLinkModalProps(
    editorCommands,
    linkSettings,
    contentQueryService,
    experiments
  );
  const openModal = () => {
    modalService.isModalOpen(id) ? modalService.closeModal(id) : modalService == null ? void 0 : modalService.openModal(id, {
      componentProps: {
        closeModal: () => modalService.closeModal(id)
      },
      layout: isMobile ? "fullscreen" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  const onClick = () => {
    const isCustomLinkHandling = !!onLinkAdd;
    if (isCustomLinkHandling) {
      const customLinkData = linkData == null ? void 0 : linkData.customData;
      const callback = (data) => editorCommands.insertDecoration(CUSTOM_LINK, data);
      onLinkAdd(customLinkData, callback);
    } else {
      openModal();
    }
  };
  const tooltip = t((_b = toolbarItem.presentation) == null ? void 0 : _b.tooltip);
  const isActive = modalService.isModalOpen(id) || toolbarItem.attributes.active;
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setReferenceElement,
      isMobile,
      active: isActive,
      tooltip,
      onClick,
      Icon: (_c = toolbarItem.presentation) == null ? void 0 : _c.icon,
      dataHook
    }
  );
};

export { EditLinkButton };
//# sourceMappingURL=edit-link-button.js.map
